var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb-2 border border-transparent" },
        [_vm._t("default")],
        2
      ),
      _c("ModalSectionsDivider"),
      _c(
        "div",
        { staticClass: "flex", class: _vm.actionClasses },
        [_vm._t("actions")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }